"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Get the host for client-side calls.
 */
var _default = () => window.location.hostname;
exports.default = _default;